import React from 'react';

export default function ProgressBar({
  value = 0,
  min = 0,
  max = 100,
  label,
  className = '',
  size = 'sm',
  trackColor = '',
  fillColor = '',
}) {
  const progress = (value - min) / (max - min);
  return (
    <div className={`${className} progress flex-grow-1 ${trackColor && `bg-${trackColor}`}`}>
      <div
        className={`progress-bar ${fillColor && `bg-${fillColor}`} ${size
          && `progress-bar-${size}`}`}
        role="progressbar"
        style={{
          width: `${Math.round(progress * 100)}%`,
        }}
        aria-valuenow={value}
        aria-valuemin={min}
        aria-valuemax={max}
      >
        {label}
      </div>
    </div>
  );
}
